function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".frame,.primary{fill:none;}.highlights-6{fill:#e8dbec;}.primary{stroke:#4f4954;stroke-linecap:round;stroke-linejoin:round;stroke-width:16px;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "frame"
}, React.createElement("rect", {
  className: "frame",
  width: 256,
  height: 256
})), React.createElement("g", {
  id: "highlights"
}, React.createElement("path", {
  id: "Combined-Shape",
  className: "highlights-6",
  d: "M127.14,228A98,98,0,0,1,32,130c0-.91,0-1.81,0-2.71,7.17.68,20.18,2.24,20.79,7.29.85,7,0,15.69,5.94,18.31s7.64-10.47,12.73-7,18.67,6.85,18.67,13-2.55,15.76,0,17.5,12.72,14,12.72,15.7,3.59,10.61,2.52,14c-.89,2.81,9.69,17.41,15.72,19.09M89.53,40.72a98.13,98.13,0,0,1,128,45.12c.36,8.5.3,15.77,2.17,18.4,9.56,13.36-23.26,22.56-18.28,42.77,2.2,8.92-21.83,6.09-27.7,14.44s-20.22,2.74-23.54,1.14-16.07,3.74-15-5.35,8.86-9.63,17.17-13.37,20.3-16.17,14.41-17.8c-27.73-7.64-37.19-34.4-37.19-34.4-1.66-.33-1.24-18.93-8.44-19.46s-11.09,2.14-21.61,0-8.31-9.09-10-24.06A27.88,27.88,0,0,1,89.53,40.72Z"
})), React.createElement("g", {
  id: "primary"
}, React.createElement("circle", {
  className: "primary",
  cx: 128,
  cy: 128,
  r: 96
}), React.createElement("path", {
  id: "Combined-Shape-2",
  "data-name": "Combined-Shape",
  className: "primary",
  d: "M124.39,224A95.19,95.19,0,0,1,32,128.85c0-.88,0-1.75,0-2.63,7,.67,19.59,2.18,20.19,7.08.82,6.77,0,15.24,5.77,17.78s7.41-10.16,12.36-6.77S88.49,151,88.49,157s-2.47,15.3,0,17,12.35,13.54,12.35,15.24,3.49,10.31,2.45,13.6c-.86,2.73,9.42,16.91,15.26,18.53M87.87,42.14A95.27,95.27,0,0,1,212.19,86c.35,8.25.28,15.31,2.11,17.86,9.27,13-22.6,21.91-17.76,41.55,2.13,8.66-21.2,5.91-26.9,14S150,162,146.78,160.48s-15.61,3.64-14.53-5.19,8.61-9.35,16.68-13,19.71-15.7,14-17.28C136,117.6,126.8,91.61,126.8,91.61c-1.61-.31-1.2-18.38-8.2-18.9s-10.76,2.08-21,0-8.07-8.82-9.68-23.37A26.6,26.6,0,0,1,87.87,42.14Z"
})));
var SvgMarketingMedium = function SvgMarketingMedium(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMarketingMedium, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MarketingMedium.f1b9537a.svg";
export { ForwardRef as ReactComponent };